import React from "react";
import {
  Box,
  Flex,
  Progress as ChakraProgress,
  ProgressProps as ChakraProgressProps,
} from "@chakra-ui/react";
import {FALArrowsRotate} from "../../icons";
import {variantOptions} from "./theme/themeOptions";

export interface ProgressProps extends Omit<ChakraProgressProps, "colorScheme"> {
  showLabel?: boolean;
  variant?: keyof typeof variantOptions;
}

const filledTrackColorOptions: Record<keyof typeof variantOptions, string> = {
  [variantOptions.primary]: "surfaces.primary.strong.resting",
  [variantOptions.success]: "surfaces.success.dominant.resting",
  [variantOptions.warning]: "surfaces.warning.strong.resting",
  [variantOptions.danger]: "surfaces.danger.dominant.resting",
};

export default function Progress(props: ProgressProps) {
  const {showLabel, isIndeterminate, value, variant = variantOptions.primary, ...rest} = props;
  const roundedValue = !value ? 0 : Math.round(value);

  return (
    <Flex gap={1} alignItems="center">
      <ChakraProgress
        value={roundedValue}
        isIndeterminate={isIndeterminate}
        flexBasis="100%"
        sx={{
          "& > div": {
            bg: filledTrackColorOptions[variant],
            ...(variant === variantOptions.warning && {
              border: "0.8px solid",
              borderColor: "components.banner.borderWarning",
            }),
          },
        }}
        {...rest}
      />
      {showLabel && (
        <Box
          as="span"
          fontSize="md"
          sx={{fontVariantNumeric: "tabular-nums"}}
          width={10}
          flexShrink={0}
          textAlign={isIndeterminate ? "center" : "right"}
        >
          {isIndeterminate ? <FALArrowsRotate mt="-3px"/> : `${roundedValue}%`}
        </Box>
      )}
    </Flex>
  );
}
